const replace = (string, mapObject, prefix = '', filter) => {
  let replacedString = string;

  Object.keys(mapObject).forEach(v => {
    const text = !!filter ? filter(mapObject[v]) : mapObject[v];

    replacedString = replacedString.replace(prefix+v, text);
  })

  return replacedString;
};

export default replace;
